export const roundFunctionProz = (value: number) => {
  return Math.round(Number(value) * 1000) / 1000;
};

export const roundFunctionNormal = (value: number) => {
  return Math.round(Number(value) * 100) / 100;
};
